export class StationModel {
    id: string | undefined;
    name: string | undefined;
    crsCode: string | undefined;
    lat: string | undefined;
    long: string | undefined;
}